import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://food.chatbooking.com.br/api'; // Use HTTPS e domínio

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken'); // Token do garçom/admin do restaurante
    const superAdminToken = localStorage.getItem('superAdminToken'); // Token do Super Admin

    if (config.url.startsWith('/admin/') || config.url.startsWith('/superadmin/')) {
      if (superAdminToken) {
        config.headers.Authorization = `Bearer ${superAdminToken}`;
      }
    } else {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const loginWaiter = async (username, password) => {
  const response = await api.post('/waiters/login', { username, password });
  if (response.data.access_token) {
    localStorage.setItem('accessToken', response.data.access_token);
    // Armazenar o RestaurantID e Role do token para uso futuro
    // Isso exigiria decodificar o token no frontend ou ter o backend retorná-los explicitamente
    // Por enquanto, vamos assumir que o token contém essas informações e que o interceptor as usará.
  }
  return response.data;
};

export const loginSuperAdmin = async (username, password) => {
  const response = await api.post('/superadmin/login', { username, password });
  // O token do super admin será armazenado no localStorage em SuperAdminLoginScreen
  return response.data;
};

export const createRestaurant = async (restaurantData) => {
  const response = await api.post('/admin/restaurants', restaurantData);
  return response.data;
};

export const getRestaurants = async () => {
  const response = await api.get('/admin/restaurants'); // Endpoint para listar todos os restaurantes
  return response.data;
};

export const getRestaurant = async (restaurantId) => {
  const response = await api.get(`/admin/restaurants/${restaurantId}`);
  return response.data;
};

export const getMenu = async () => {
  const response = await api.get('/menu');
  return response.data;
};

export const getTables = async () => {
  const response = await api.get('/tables');
  return response.data;
};

export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData);
  return response.data;
};

export const getOrdersByDestination = async (destination) => {
  const response = await api.get(`/orders/${destination}`);
  return response.data;
};

export const markOrderReady = async (orderId) => {
  const response = await api.patch(`/orders/${orderId}/ready`);
  return response.data;
};

// Funções para o Admin do Restaurante
export const loginRestaurantAdmin = async (cnpj, password) => {
  const response = await api.post('/restaurant/login', { cnpj, password });
  if (response.data.access_token) {
    localStorage.setItem('accessToken', response.data.access_token); // Usar o mesmo accessToken para admins de restaurante
  }
  return response.data;
};

export const getRestaurantProfile = async () => {
  const response = await api.get('/restaurant/profile');
  return response.data;
};

export const updateRestaurantProfile = async (restaurantData) => {
  const response = await api.put('/restaurant/profile', restaurantData);
  return response.data;
};

export const createRestaurantUser = async (userData) => {
  const response = await api.post('/restaurant/users', userData);
  return response.data;
};

export const getRestaurantUsers = async () => {
  const response = await api.get('/restaurant/users');
  return response.data;
};

export const getRestaurantUser = async (userId) => {
  const response = await api.get(`/restaurant/users/${userId}`);
  return response.data;
};

export const updateRestaurantUser = async (userId, userData) => {
  const response = await api.put(`/restaurant/users/${userId}`, userData);
  return response.data;
};

export const deleteRestaurantUser = async (userId) => {
  const response = await api.delete(`/restaurant/users/${userId}`);
  return response.data;
};

export const createMenuItem = async (itemData) => {
  const response = await api.post('/restaurant/menuitems', itemData);
  return response.data;
};

export const getMenuItems = async () => {
  const response = await api.get('/restaurant/menuitems');
  return response.data;
};

export const getMenuItem = async (itemId) => {
  const response = await api.get(`/restaurant/menuitems/${itemId}`);
  return response.data;
};

export const updateMenuItem = async (itemId, itemData) => {
  const response = await api.put(`/restaurant/menuitems/${itemId}`, itemData);
  return response.data;
};

export const deleteMenuItem = async (itemId) => {
  const response = await api.delete(`/restaurant/menuitems/${itemId}`);
  return response.data;
};

export const createDevice = async (deviceData) => {
  const response = await api.post('/restaurant/devices', deviceData);
  return response.data;
};

export const getDevices = async () => {
  const response = await api.get('/restaurant/devices');
  return response.data;
};

export const getDevice = async (deviceId) => {
  const response = await api.get(`/restaurant/devices/${deviceId}`);
  return response.data;
};

export const updateDevice = async (deviceId, deviceData) => {
  const response = await api.put(`/restaurant/devices/${deviceId}`, deviceData);
  return response.data;
};

export const deleteDevice = async (deviceId) => {
  const response = await api.delete(`/restaurant/devices/${deviceId}`);
  return response.data;
};

export default api;
